/* eslint-disable import/prefer-default-export */
import React from 'react';
import { useQuery, useQueryClient } from '@tanstack/react-query';
import QueryKeys from '../config';
import API from '../../../network';
import { Currency, CurrencyOption } from './types';

export const mapCurrenciesToOptions = (data: Currency[] = []): CurrencyOption[] => data
  .filter((item) => item.status === 'ACTIVE')
  .map((item) => ({
    currencyName: item.code,
    currencyIcon: item.symbol,
    id: item.id,
    name: item.name,
  }));

const useCurrencies = (props?: { enabled?: boolean; includeInactive?: boolean }) => {
  const { enabled } = props || { enabled: true };
  const includeInactive = props?.includeInactive || false;
  const queryClient = useQueryClient();

  const {
    isLoading, data, error, refetch,
  } = useQuery({
    queryKey: includeInactive ? QueryKeys.CURRENCIES_ALL : QueryKeys.CURRENCIES,
    queryFn: async () => (includeInactive
      ? API.getInstance().fetchAllCurrencies()
      : API.getInstance().fetchCurrencies()),
    refetchOnWindowFocus: false,
    initialData: [],
    enabled,
  });

  const currenciesOptions = React.useMemo(
    () => mapCurrenciesToOptions(data),
    [data],
  );

  const invalidateCurrencies = () => {
    queryClient.invalidateQueries({ queryKey: QueryKeys.CURRENCIES });
    queryClient.invalidateQueries({ queryKey: QueryKeys.CURRENCIES_ALL });
  };

  return {
    currenciesLoading: isLoading,
    currenciesOptions,
    data,
    error,
    fetchCurrencies: refetch,
    invalidateCurrencies,
  };
};

export {
  useCurrencies,
};
